import React, { Component } from "react";
import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import Calender from "../calender";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { redirect } from "../../../slices/sbHebergSlice";
import httpClient from "../../../httpClient";
import { faMapMarkerAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UrlParams from "../urlParams";
import { Slider} from "@mui/material";
import { searchedLocation, sideBarLocation } from "../../../slices/sbLocation";

class SideBarLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams :{
        pays: "",
        region: "",
        commune: "",
        dateDebut: "",
        dateFin: "",
        restitution:[],
        kilometrage:[],
        type: [],
        conditions: [],
        equipement: [],
        kilosMax:100,
        kilosMin : 0,
        budget : null,
        budgetIntervale : [],
        kilosIntervale :[]
      },
      autocompletePlaces:[],
      showAutoComp : false
    };
    this.showAutoComp = this.showAutoComp.bind(this);

  }


 async componentDidUpdate(prevProps, prevState) {
    this.props.dispatch(sideBarLocation(this.state.searchParams));
    if(this.props.redirect===true && prevProps.url !== this.props.url){
      console.log(this.props.url);
      this.props.history.push("/cars/location/advanced_search"+"?"+this.props.url)
      const searchedAnnounces = await httpClient.getAllCarsLocation(this.props.url)
      this.props.dispatch(searchedLocation(searchedAnnounces))
      this.props.dispatch(redirect(false))
    }
  }

  async componentDidMount(){
    let completeUrl = decodeURIComponent(window.location.href.toString())
    let prms = completeUrl.replace(window.location.hostname.toString() , "").replace(window.location.pathname.toString() , "")
    let pos = prms.indexOf("?")
    prms = prms.substring(pos+1,prms.length)
    let urlParams = new UrlParams(prms,0).params
    let obj = this.state.searchParams

    Object.entries(urlParams).map(prop =>{
     if (prop[0] ==="type" || prop[0] ==="conditions" || prop[0] ==="equipement") {
      obj[prop[0]] = prop[1].replaceAll('+'," ").split(',')
     }
     else obj[prop[0]] = prop[1]
    })
    this.setState({
      searchParams : obj
    })
    const searchedAnnounces = await httpClient.getAllCarsLocation(this.props.url||prms)

    this.props.dispatch(searchedLocation(searchedAnnounces))
    this.props.dispatch(redirect(false))
  }

  isExist(type , value){
    let copie = this.state.searchParams[type]
    return copie.includes(value)
  }

  changeState(evt) {
    let value = evt.target.value;
    let name = evt.target.name;
    const copie = this.state.searchParams[name];
    
    this.setState({
      searchParams : {
        ...this.state.searchParams,
      [name]: value,
      }
      
    });

    if (evt.target.type === "radio") {
      this.setState({
        searchParams : {
          ...this.state.searchParams,
          budget: value,
        }
      });
    } else if ((evt.target.type === "checkbox")) {
      let index = copie.indexOf(value);
      if (index === -1) {
        this.setState({
          searchParams : {
            ...this.state.searchParams,
            [name]: [...this.state.searchParams[name], value],
          }
        });
      } else {
        this.setState({ 
          searchParams : {
            ...this.state.searchParams,
            [name]: copie.filter((item) => item !== value),
          }
        });
      }
    }
  }

  city(e,city,country){
    e.preventDefault()
    this.setState({
      searchParams : {
        ...this.state.searchParams,
        pays: country,
        region:city,
      },
      showAutoComp : false
      },
    )
  }

  handleChangeKilos =  (event, newValue) => {
    let kilosIntervale ;
    switch (newValue) {
      case 0:
        kilosIntervale = "0-50000"
        break;
      case 25:
        kilosIntervale = "50000-100000"
        break;
      case 50:
        kilosIntervale = "10000-200000"
      case 75:
        kilosIntervale = "200000-300000"
      case 100:
        kilosIntervale = "300000-9999999"
        break;   
      default:
        break;
    }
    this.setState({
      searchParams: {
        ...this.state.searchParams,
        kilosMin : newValue[0],
        kilosMax:newValue[1],
        kilosIntervale :kilosIntervale
      }
    })
  };

  handleChangeBudget = async (event, newValue) => {
    let budgetIntervale ;
    newValue = parseInt(newValue)
     switch  (newValue) {
      case 0:
        budgetIntervale = "0-50000";
        break;
      case 25:
        budgetIntervale = "50000-100000";
        break;
      case 50:
        budgetIntervale = "10000-200000";
      case 75:
        budgetIntervale = "200000-300000";
      case 100:
        budgetIntervale = "300000-9999999";
        break;   
      default:
        budgetIntervale = "0-9999999";
        break;
    }
    this.setState({
      searchParams: {
        ...this.state.searchParams,
        budget : newValue,
        budgetIntervale :budgetIntervale
      }
    })

  };

   autoComplete(evt) {
    try {
      if (evt.target.value !=="") {
        // httpClient.autocompletePlaces(evt.target.value).then((res)=>{
        //   if (res){ 
        //     this.showAutoComp(true)
        //     return this.setState({autocompletePlaces:res.data})  
        //   }
        //}
        //)
      
      }
        
      
    } catch (error) {
      console.log(error);
    }
  }

  showAutoComp(value){
    this.setState({
      showAutoComp : value
    })
  }
  
    render() { 
          

        const marks = [
            // Save the fetched values here instead of under <Slider value=...>
            { value: 0, label: '<50k' },
            { value: 25, label: '50k-100k' },
            { value: 50, label: '100k-200k' },
            { value: 75, label: '200k-300k' },
            { value: 100, label: '+300k' },
          ];

      const showAutoComp = this.state.showAutoComp
      const region  = this.state.searchParams.region
      const citiesDepart =  <DropdownItem className="pl-1"  onMouseDown={e=>{this.city.bind(this)(e,region,"Algerie")}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name="region"/> {region}</DropdownItem>

      // const citiesDepart = this.state.autocompletePlaces.map((city,i)=>{
      //   const cityName = city.name ;
      //   const code = city.address.cityCode;
      //   const country = city.address.countryCode;
      //   const countryName = city.address.countryName;
      //   return (
      //    <DropdownItem className="pl-1" id={`cityDep`+i} key={city.address.cityCode} onMouseDown={e=>{this.city.bind(this)(e,cityName,countryName)}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name={city.address.cityCode}/> {cityName} ({code}, {country})</DropdownItem>
      //   )},this)
  
      const carType = ["Mini Citadine","Citadine","Berline","Moyenne Berline","SUV Tout-terrain","Grande Berline","Break Familliale","Coupé Cabriolet","Van","Mini Bus","Bus / Navette"]
      const condReserv= ["Annulation gratuite", "Paiment sur place" ," Paiment électronique", "Paiment sécurisé sur site"]
      const equipement = ["Direction Assistée","Climatisation/Chaufage","Siège Bébé","Porte Bagage","ABS","ESP","GPS","Climatisation Bi-Directionnelle","Ordinateur de Bord","Radar De  Recul","Vitres électrique","Vitres Taintés","Prisses Usb", "Prise Jack 3.5mm","Démarage a Bouton","Changement Sans-Fil","Réfrigerateur","Alarme"]
      const restitution = ["Restitution dans un endroit différent","Sans Chauffeur seulement","avec Chaufeur seulement","Conducteur entre 30 et 65 ans"]
      
      const restitutionElm = []
      const carTypeeElm = [] ;
      const equiElm = [];  
      const condReservElm = [] ;




      carType.forEach(elm =>{
        carTypeeElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='type' type="checkbox" value={elm} checked={this.isExist("type",elm)} />{elm}</Label></FormGroup>
        )
      })
      condReserv.forEach(elm =>{
        condReservElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name="conditions" type="checkbox" value={elm} checked={this.isExist("conditions",elm)} />{elm}</Label></FormGroup>
          )
      })
      equipement.forEach(elm =>{
        equiElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='equipement' type="checkbox" value={elm} checked={this.isExist("equipement",elm)} />{elm}</Label></FormGroup>
          )
      })
      restitution.forEach(elm=>{
        restitutionElm.push(
            <FormGroup check className="form-check-sidebar"><Label check><Input name='restitution' type="checkbox" value={elm} checked={this.isExist("restitution",elm)} />{elm}</Label></FormGroup>
        )
      })
        return ( 
            <Container>
            <br />
          <center><span className="side-bar-txt header-sd-br">Recherche Avancée</span></center>
          <br />
          <div>
          <form onChange={e=>{this.changeState(e)}}>
          <div>
          <div className="lablel-sidebar" id="cancel-side">Lieu de ramassage</div>
                <UncontrolledDropdown nav inNavbar>
                    <input onChange={e=>this.changeState(e)} onInput={e=>this.autoComplete(e)} onFocus={e=>this.showAutoComp(true)}  onBlur={e=>this.showAutoComp(false)} id="destination" className="Advanced-btn-ser small" placeholder='Turquie' style={{width:"100%",backgroundColor:"white",color:"#37296a"}} name="region" value={this.state.searchParams.region}/>
                    <DropdownMenu className={`${showAutoComp&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesDepart}
                             </div>
                            <span id="recent-title">Récents</span>
                             <hr />
                             <div className="result-block">
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Paris,France</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Ibiza,Espagne</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} /> Dubai,UAE</div>
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown>





                  <div className='d-flex justify-content-between'>

                    <div style={{width:"49%"}}>
                      <span className="lablel-sidebar">Date Départ</span>
                       <input type="date" style={{width:"100%"}} className="pr-0"/>
                    </div>


                    <div style={{width:"49%"}}>
                      <span className="lablel-sidebar">Date Arrivé</span>
                       <input type="date" style={{width:"100%"}} className="pr-0"/>
                    </div>
                </div> 

                <div className="mt-2">
                {restitutionElm}
                </div>
                

                <div className="options-sidebar mt-2">
                <div className="lablel-sidebar-bidget mb-1">Type de Véhicule</div>
                {carTypeeElm}
                </div>


                <div className="lablel-sidebar mt-3">Votre budget</div>
                <div className="mr-1 ml-1">
                <Slider
                  getAriaLabel={() => 'Temperature range'}
                  value={this.state.searchParams.budget}
                  onChange={(event, newValue)=>this.handleChangeBudget(event,newValue)}
                  min ={0}
                  max={100}
                  marks={marks}                  
                  className={"slider-white"}  
                  step={null}  
                  />    
                </div>


                <div className="options-sidebar mt-2">
                 <div className="lablel-sidebar-bidget mb-1">Condition de réservation</div>
                 {condReservElm}
                 </div>

                 <div className="options-sidebar mt-3">
                 <div className="lablel-sidebar-bidget mb-1">Véhicule</div>
                 </div>

                 <div className='d-flex mt-2 align-items-center'>
                 <span className="lablel-sidebar mr-2">Marque</span>
                  <UncontrolledDropdown className='mr-2' style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                          Skoda
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>


                  <UncontrolledDropdown  style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                         Octavia 
                         <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>

                </div>

                <div className='d-flex mt-2 align-items-center'>
                <span className="lablel-sidebar mr-1">Energie</span>
                  <UncontrolledDropdown className='mr-2' style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                          Ess
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>


                <span className="lablel-sidebar mr-2 ">Année</span>
                  <UncontrolledDropdown  style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                         2018 
                         <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>

                </div>

                <div className='row mx-0 mt-2 justify-content-between d-flex align-items-center'>
                <span className="lablel-sidebar">Type de transmition</span>
                  <UncontrolledDropdown  style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                          Manuelle
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>

                </div>

                <div className='d-flex mt-2 align-items-center'>
                    <span className="lablel-sidebar mr-1">Couleur</span>
                  <UncontrolledDropdown className='mr-2' style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                          Gris  
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>


                 <span className="lablel-sidebar mr-2">Siège</span>
                  <UncontrolledDropdown  style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="Advanced-btn-ser small" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                         4+1 
                         <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                          </DropdownToggle>
                </UncontrolledDropdown>

                </div>

                <div className="lablel-sidebar mt-3">Kilométrage</div>
                <div className="mr-1 ml-1">
                <Slider
                  getAriaLabel={() => 'Temperature range'}
                  value={[this.state.searchParams.kilosMin ,this.state.searchParams.kilosMax]}
                  onChange={(event, newValue)=>this.handleChangeKilos(event,newValue)}
                  min ={0}
                  max={100}
                  marks={marks}                  
                  className={"slider-white"}  
                  step={null}  
                  />    
                </div>

                 <div className="options-sidebar mt-2 mb-4">
                 <div className="lablel-sidebar-bidget mb-1">Equipements</div>                  
                 {equiElm}
                 </div>
                </div>
                </form>
         </div>
         
          </Container>
         );
    }
}
 

function mapStateToProps(state) {
  return {
    url : state.sideBarCarsLocation.url,
    redirect : state.sideBarCarsLocation.redirect,
    params : state.sideBarCarsLocation.sideBar
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(SideBarLocation));